import { render, staticRenderFns } from "./CompanyComplaintJBJ.vue?vue&type=template&id=074af250&"
import script from "./CompanyComplaintJBJ.vue?vue&type=script&lang=js&"
export * from "./CompanyComplaintJBJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports